<template>
  <svg
    id="Layer_1"
    version="1.1"
    xmlns:x="ns_extend;"
    xmlns:i="ns_ai;"
    xmlns:graph="ns_graphs;"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 226 64"
    style="enable-background:new 0 0 226 64;"
    xml:space="preserve"
    fill="#FA5022"
  >
    <g>
      <path
        class="st0"
        d="M200.6,51.9c-7,0-12.6-5.9-12.6-13.2c0-7.3,5.7-13.2,12.6-13.2c7,0,12.6,5.9,12.6,13.2
 C213.3,46,207.6,51.9,200.6,51.9L200.6,51.9z M213.3,14.6v6.7c-1.8-2.5-4.2-4.5-6.9-5.8c-2.7-1.4-5.7-2.1-8.8-2.1
 c-12.5,0-22.2,11.3-22.2,25.3c0,14,9.7,25.3,22.2,25.3c3.3,0,6.5-0.8,9.4-2.4c2.9-1.6,5.3-3.8,7.1-6.6v7.8h12V14.6L213.3,14.6z
 M67.2,1.2h12.8v61.6H67.2V1.2z M94.6,35.5c0-13.2,8-22.1,19.2-22.1c6.9,0,12.4,3.1,15.7,8.4c3.3-5.3,8.8-8.4,15.7-8.4
 c11.2,0,19.2,8.9,19.2,22.1v27.3h-12.8V34.1c0-5.2-3.4-8.5-7.9-8.5s-7.9,3.4-7.9,8.5v28.7h-12.8V34.1c0-5.2-3.4-8.5-7.9-8.5
 c-4.5,0-7.9,3.4-7.9,8.5v28.7H94.6L94.6,35.5z M44.1,15.1C41.1,3.7,34.7,0,28.6,0c-6.1,0-12.5,3.7-15.5,15.1L0,62.8h12.9
 c0.9-3.5,2.9-6.7,5.7-8.9c2.8-2.3,6.3-3.5,10-3.5s7.1,1.2,10,3.5c2.8,2.3,4.9,5.4,5.7,8.9h12.9L44.1,15.1z M28.6,39.3
 c-3.9,0-7.7,1.5-10.6,4.1l7.4-27.8c0.7-2.7,1.8-3.5,3.2-3.5c1.4,0,2.5,0.8,3.2,3.5l7.4,27.8C36.3,40.7,32.5,39.3,28.6,39.3z"
      />
    </g>
  </svg>
</template>
